/**
 * Menu per l'inserimento dei placeholder dinamici nel corpo (§11.5).
 * Inserisce il token come testo nella posizione corrente del cursore.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, MenuItem, ListItemText } from '@mui/material';
import DataObjectIcon from '@mui/icons-material/DataObject';
import { PLACEHOLDERS } from '../../../../../utils/newsletter/emailHtml';

/**
 * @param {{ editor: import('@tiptap/react').Editor|null, disabled?: boolean }} props
 */
export function PlaceholderMenu({ editor, disabled }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  if (!editor) return null;

  const handleInsert = (token) => {
    editor.chain().focus().insertContent(token).run();
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size="small"
        startIcon={<DataObjectIcon fontSize="small" />}
        disabled={disabled}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color: '#212b36', textTransform: 'none' }}
      >
        Inserisci campo
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {PLACEHOLDERS.map((p) => (
          <MenuItem key={p.token} onClick={() => handleInsert(p.token)}>
            <ListItemText primary={p.label} secondary={p.token} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

PlaceholderMenu.propTypes = {
  editor: PropTypes.object,
  disabled: PropTypes.bool,
};

export default PlaceholderMenu;